import { render, staticRenderFns } from "./DownloadBoard.vue?vue&type=template&id=8d6c9264&"
import script from "./DownloadBoard.vue?vue&type=script&lang=js&"
export * from "./DownloadBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports